window.product = window.product || {};

window.product.addons =
{
    _eventsHooked: false,

    bindCart: function (root)
    {
        root = root || document;

        // Find all cart addon rows that are not yet bound
        const forms = root.querySelectorAll('[data-cart-addon-row-id] form');

        for (let form of forms)
            product.addons.bindCartForm(form);

        if (forms.length < 1)
            return;

        if (product.addons._eventsHooked)
            return;

        document.addEventListener("onElementContentChanged", function (event)
        {
            var forms = event.detail.node.querySelectorAll('[data-cart-addon-row-id] form');

            if (!forms)
                return;

            for(let form of forms)
                product.addons.bindCartForm(form);
        });

        product.addons._eventsHooked = true;
    },
    bindCartForm: function (form)
    {
        if (!form || form.dataset.addonsBound === "true")
            return;

        const cartItemId = form.dataset.cartItemId;
        const hiddenJson = form.querySelector('input[name="Addons"][data-json="true"]');

        if (!cartItemId || !hiddenJson)
        {
            form.dataset.addonsBound = "true"; // prevent re-tries in this render

            return;
        }

        // Helpers to work across all forms for the same cart item
        function getAllFormsForCartItem()
        {
            const forms = document.querySelectorAll(`form[data-cart-item-id="${CSS.escape(cartItemId)}"]`);

            return Array.from(forms);
        }

        function getAllCheckboxesForCartItem()
        {
            return getAllFormsForCartItem()
                .flatMap(f => Array.from(f.querySelectorAll('input[type="checkbox"][data-addon-id]')));
        }

        function getAllQtyInputsForCartItem()
        {
            return getAllFormsForCartItem()
                .flatMap(f => Array.from(f.querySelectorAll('[data-addon-quantity]')));
        }

        function syncTwinCheckboxes(addonId, checked)
        {
            getAllCheckboxesForCartItem()
                .filter(cb => cb.dataset.addonId === String(addonId))
                .forEach(cb => { cb.checked = checked; });
        }

        function enforceGroupExclusivity(changedCb)
        {
            const group = (changedCb.dataset.group || '').trim();

            if (!changedCb.checked || !group)
                return;

            getAllCheckboxesForCartItem().forEach(cb =>
            {
                if (cb === changedCb)
                    return;

                if ((cb.dataset.group || '').trim() === group)
                    cb.checked = false;
            });
        }

        function findQtyFor(addonId, preferredForm)
        {
            // Prefer qty from the preferredForm (the origin), fallback to any other form
            const fromPreferred = preferredForm?.querySelector(`[data-addon-id="${addonId}"][data-addon-quantity]`);

            if (fromPreferred)
            {
                const v = Math.max(1, parseInt(fromPreferred.value) || 1);

                return isFinite(v)
                    ? v
                    : null;
            }

            const other = getAllQtyInputsForCartItem().find(i => i.getAttribute('data-addon-quantity') === String(addonId));

            if (!other)
                return null;

            const v2 = Math.max(1, parseInt(other.value) || 1);

            return isFinite(v2)
                ? v2
                : null;
        }

        function rebuildPayload(originForm)
        {
            const payload = {};

            // Walk across all forms for this cartItemId and gather states per addonId
            const checkboxes = getAllCheckboxesForCartItem();

            // Deduplicate by addonId (prefer state from origin first)
            const map = new Map();

            checkboxes.forEach(cb =>
            {
                const id = parseInt(cb.dataset.addonId);

                if (!Number.isFinite(id))
                    return;

                const current = map.get(id);
                const record = {
                    checkbox: cb,
                    fromOrigin: (originForm && originForm.contains(cb)),
                };

                // Prefer origin form checkbox state; otherwise keep the first seen
                if (!current || record.fromOrigin && !current.fromOrigin)
                    map.set(id, record);
            });

            map.forEach((rec, id) =>
            {
                const cb = rec.checkbox;
                const selected = cb.checked;
                const isQty = cb.dataset.isQuantityChangeable === 'true';
                const qty = isQty
                    ? findQtyFor(id, originForm && originForm.querySelector(`input[data-addon-id="${id}"][data-addon-quantity]`) !== null ? originForm : null)
                    : null;
                const wasSelected = cb.dataset.wasSelected === 'true';

                // Include:
                // - selected items (Selected=true)
                // - previously selected but now unchecked (Selected=false) => to remove
                // - quantity present (edge case) — UI already auto-checks, but keep safe
                if (selected || wasSelected || qty !== null)
                {
                    payload[id] = {
                        Selected: selected,
                        Quantity: qty
                    };
                }
            });

            hiddenJson.value = JSON.stringify(payload);
        }

        let saveTimer = null;

        const debounce = (fn, ms) =>
        {
            clearTimeout(saveTimer);

            saveTimer = setTimeout(fn, ms);
        };

        form.addEventListener('change', function (e)
        {
            // Check/uncheck in this form: enforce exclusivity across all forms for this cart item
            if (e.target.matches('input[type="checkbox"][data-addon-id]'))
            {
                // Keep both (mobile/desktop) checkboxes for the same addon in sync
                syncTwinCheckboxes(e.target.dataset.addonId, e.target.checked);

                enforceGroupExclusivity(e.target);
            }

            // If user changes quantity in this form, auto-check its sibling checkbox (if exists)
            if (e.target.matches('[data-addon-quantity]'))
            {
                const id = e.target.getAttribute('data-addon-quantity');
                const cb = form.querySelector(`input[type="checkbox"][data-addon-id="${id}"]`)
                    || getAllCheckboxesForCartItem().find(c => c.dataset.addonId === String(id));

                if (cb && !cb.checked)
                {
                    cb.checked = true;

                    syncTwinCheckboxes(id, true);
                    enforceGroupExclusivity(cb);
                }
            }

            rebuildPayload(form);

            debounce(() =>
            {
                // Submit only this form (origin)
                window.submitApiForm(form);
            }, 250);
        });

        // Initial payload must include currently selected addons to prevent accidental removal
        rebuildPayload();

        form.dataset.addonsBound = "true";
    },
    init: function ()
    {
        product.addons.initWrapper();

        // Cart addons
        product.addons.bindCart(document);
    },
    initWrapper: function ()
    {
        var wrapper = document.getElementById("product-addons");

        if (!wrapper)
            return;

        let checkboxes = wrapper.querySelectorAll("[data-addon-id]");

        for (let checkbox of checkboxes)
        {
            checkbox.addEventListener("change", product.addons.changeHandler);

            // Initialize quantity visibility
            if (checkbox.checked && checkbox.dataset.isQuantityChangeable === 'true')
            {
                var quantityContainer = document.querySelector(`[data-addon-quantity="${checkbox.dataset.addonId}"]`);

                if (quantityContainer)
                    quantityContainer.style.display = 'flex';
            }
        }

        // Toggle button
        var toggleButton = document.getElementById("product-addons-toggle");

        if (toggleButton)
            toggleButton.addEventListener("click", product.addons.toggleHandler);

        // Handle quantity input changes
        var quantityInputs = document.querySelectorAll('[data-addon-quantity-input]');

        for (let input of quantityInputs)
            input.addEventListener("change", product.addons.updateAddonsData);

        // Update product quantity input to update addon max quantities
        var productQuantityInput = document.querySelector("[data-quantity]");

        if (productQuantityInput)
            productQuantityInput.addEventListener("change", product.addons.quantityHandler);

        // Initialize on page load
        product.addons.updateAddonsData();
    },
    changeHandler: function (event)
    {
        var addonId = this.dataset.addonId;

        var quantityContainer = document.querySelector(`[data-addon-quantity="${addonId}"]`);

        var isQuantityChangeable = this.dataset.isQuantityChangeable === 'true';

        if (quantityContainer && isQuantityChangeable)
        {
            quantityContainer.style.display = this.checked
                ? 'flex'
                : 'none';
        }

        // Handle group exclusivity
        if (this.checked && this.name.startsWith('addon-group-'))
        {
            var others = document.querySelectorAll(`input[name="${this.name}"]`);

            for (let other of others)
            {
                if (other === this)
                    continue;

                other.checked = false;

                var otherAddonId = other.dataset.addonId;
                var otherQuantityContainer = document.querySelector(`[data-addon-quantity="${otherAddonId}"]`);

                if (otherQuantityContainer)
                    otherQuantityContainer.style.display = 'none';
            }
        }

        product.addons.updateAddonsData();
    },
    quantityHandler: function ()
    {
        var productQuantity = parseInt(this.value) || 1;

        var quantityInputs = document.querySelectorAll('[data-addon-quantity-input]');

        for (let input of quantityInputs)
        {
            var addonId = input.dataset.addonQuantityInput;
            var checkbox = document.querySelector(`[data-addon-id="${addonId}"]`);
            var maxQuantity = parseInt(checkbox.dataset.maxQuantity) || 0;

            if (maxQuantity > 0)
                input.max = Math.min(maxQuantity, productQuantity);
            else
                input.max = productQuantity;

            // Adjust current value if it exceeds new max
            if (parseInt(input.value) > parseInt(input.max))
                input.value = input.max;
        }

        product.addons.updateAddonsData();
    },
    toggleHandler: function ()
    {
        var isExpanded = this.getAttribute('aria-expanded') === 'true';
        var labelSpan = this.querySelector('span');

        if (labelSpan)
        {
            labelSpan.textContent = isExpanded
                ? labelSpan.dataset.labelCollapsed
                : labelSpan.dataset.labelExpanded;
        }

        this.setAttribute('aria-expanded', !isExpanded);
    },
    updateAddonsData: function ()
    {
        var productQuantityInput = document.querySelector('[data-quantity]');

        var addons = [];
        var productQuantity = parseInt(productQuantityInput?.value) || 1;

        var checkboxes = document.querySelectorAll('[data-addon-id]:checked');

        for (let checkbox of checkboxes)
        {
            var addonId = checkbox.dataset.addonId;

            var isQuantityChangeable = checkbox.dataset.isQuantityChangeable === 'true';

            var quantityInput = document.querySelector(`[data-addon-quantity-input="${addonId}"]`);

            var quantity = isQuantityChangeable && quantityInput
                ? parseInt(quantityInput.value) || 1
                : productQuantity;

            addons.push(
            {
                ProductAddonId: parseInt(addonId),
                Quantity: quantity
            });
        }

        var hidden = document.getElementById('product-addons-data');

        if (hidden)
            hidden.value = JSON.stringify(addons);
    }
};